import { 
  Dialog, 
  DialogContent, 
  DialogTitle, 
  IconButton, 
  Divider,
  DialogActions,
  Button
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import { WarningAmber } from '@mui/icons-material';
import { useContext } from 'react';
import WorkOrderContext from '../context/WorkOrderContext';
import { useMRTableModalsContext } from '../context/MRTableModalsContext';
import { formatPhoneNumber } from '../utils/PhoneNumber';

const LyftRideCanceledDialog = ({open, onClose, WO, customerName, mobile, setCurrentWorkOrder, openRequestRideDialog}) => {
  
  const { canceledLyftWorkOrder, setCanceledLyftWorkOrder } = useContext(WorkOrderContext);
  const { onCloseDialogsByLyftCancel } = useMRTableModalsContext();

  const handleLyftDialog = () => {
    setCurrentWorkOrder(canceledLyftWorkOrder)
    setCanceledLyftWorkOrder(null);
    onCloseDialogsByLyftCancel();
    openRequestRideDialog();
    onClose();
  }

  const closeDialog = () => {
    setCanceledLyftWorkOrder(null);
    onCloseDialogsByLyftCancel();
    onClose();
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby='canceled-ride-title'
      aria-describedby='canceled-ride-description'
      PaperProps={{ sx: { minWidth: '40em' } }}
    >

      <Divider sx={{ borderColor: '#FDC203', borderWidth: '4.5px' }}/>

      <DialogTitle
        sx={{ fontSize: '16px', fontWeight: '800', textTransform: 'uppercase', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
        id='information-title'
      >
        Ride has been canceled
        <IconButton
          aria-label='close modal'
          onClick={() => closeDialog()}
        >
          <CloseIcon style={{ padding: 0 }} />
        </IconButton>
      </DialogTitle>

      <Divider sx={{ marginX: '20px' }}/>

      <DialogContent className='flex items-center text-base'>
        <WarningAmber fontSize='large' sx={{mr: 2}}/>
        <div>
          A ride has been canceled by Lyft. You can request another one.
          <div>
            <ul>
              <li>
                Work order: <label className='font-bold'>{ WO }</label>
              </li>
              <li>
                Customer name: <label className='font-bold'>{ customerName }</label>
              </li>
              <li>
                Mobile: <label className='font-bold'>{ formatPhoneNumber(mobile) }</label>
              </li>
            </ul>
          </div>
        </div>
      </DialogContent>

      <DialogActions>
        <Button type="submit" variant="contained" className='button red w-1/3' onClick={() => handleLyftDialog()}>
          Request new ride
        </Button>
        <Button variant="contained" className='button w-1/4' onClick={() => closeDialog()}>
          Close
        </Button>
      </DialogActions>

    </Dialog>
  )
}

LyftRideCanceledDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  WO: PropTypes.string,
  customerName: PropTypes.string,
  mobile: PropTypes.string,
  setCurrentWorkOrder: PropTypes.func,
  openRequestRideDialog: PropTypes.func
};

LyftRideCanceledDialog.defaultProps = {
  open: false,
  onClose: () => {},
  WO: '',
  customerName: '',
  mobile: '',
  setCurrentWorkOrder: () => {},
  openRequestRideDialog: () => {}
};

export default LyftRideCanceledDialog;